module.exports = __webpack_public_path__ + "static/media/307.cb0ea96e.png";